import { NgModule } from '@angular/core';
import {
    StripeComponent, FooterComponent, HeaderComponent,
    SideMenuComponent, TeamHeaderComponent, LoginComponent,
    PreventPageLeaveComponent, AccountFooterComponent,
    ValidateTicketsComponent, RecoverPasswordComponent, EventInfoComponent,
    DisplayMessageComponent, ReceiptComponent, AccordionListComponent,
    SportFilterComponent, CartIconComponent, IosWalletComponent, GoogleWalletComponent,
    ProgressBarComponent, DateFilterComponent, PackageInfoComponent, TicketGuardianComponent,
    TransferTicketsComponent, TicketActionsComponent, CustomFormsComponent, SponsorContactComponent, TextTicketsComponent,
    StadiumSectionMapPopoverComponent, StadiumSectionMapComponent
} from '@varsity/components';
import { IonicModule } from 'ionic-angular';
import { PromoCodeComponent } from './promo-code/promo-code';
import { PriceSelectionComponent } from './price-selection/price-selection';

@NgModule({
    declarations: [
        FooterComponent,
        HeaderComponent,
        AccountFooterComponent,
        PreventPageLeaveComponent,
        LoginComponent,
        EventInfoComponent,
        SponsorContactComponent,
        PackageInfoComponent,
        RecoverPasswordComponent,
        ValidateTicketsComponent,
        SideMenuComponent,
        TeamHeaderComponent,
        StripeComponent,
        ReceiptComponent,
        DisplayMessageComponent,
        CustomFormsComponent,
        AccordionListComponent,
        SportFilterComponent,
        CartIconComponent,
        IosWalletComponent,
        GoogleWalletComponent,
        PromoCodeComponent,
        ProgressBarComponent,
        DateFilterComponent,
        TicketGuardianComponent,
        TransferTicketsComponent,
        TextTicketsComponent,
        PriceSelectionComponent,
        TicketActionsComponent,
        StadiumSectionMapComponent,
        StadiumSectionMapPopoverComponent
    ],
    imports: [
        IonicModule
    ],
    exports: [
        FooterComponent,
        HeaderComponent,
        AccountFooterComponent,
        PreventPageLeaveComponent,
        LoginComponent,
        EventInfoComponent,
        SponsorContactComponent,
        PackageInfoComponent,
        RecoverPasswordComponent,
        ValidateTicketsComponent,
        SideMenuComponent,
        TeamHeaderComponent,
        StripeComponent,
        ReceiptComponent,
        DisplayMessageComponent,
        AccordionListComponent,
        SportFilterComponent,
        CartIconComponent,
        IosWalletComponent,
        GoogleWalletComponent,
        PromoCodeComponent,
        ProgressBarComponent,
        DateFilterComponent,
        TicketGuardianComponent,
        TransferTicketsComponent,
        TextTicketsComponent,
        TicketActionsComponent,
        PriceSelectionComponent,
        StadiumSectionMapComponent,
        StadiumSectionMapPopoverComponent
    ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts